import { useEffect, useRef, useState } from "react"
import LineChart from "../../Components/highChart/new/NewLineChartGraficoElecciones"
import { listaColoresChart } from "../../Components/shared/colores";
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { getEcenariosFuente, getEmpresasFuente, getFuenteGrafico, getGraficoPagina } from '../../services/service';
import highchartsSeriesLabel from 'highcharts/modules/series-label'; // Importar el módulo series-label
import Highcharts from 'highcharts'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loading from "../../Components/shared/Loading/Loading";

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 11 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition, fontSize: 14};
    }
};

const GraficoELecciones = () => {
    const divRef = useRef(null);

    const [data, setdata] = useState({tituloProps:'',subtitleProps:'',selectValueProsp:[],formatDataStringData:'%',disableFilterProps:true,numDecimalProps:0,pieTextProps:'',showPieTextInGraph:true,showLineTop:true,showSeries:true})
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [stateLoading, setstateLoading] = useState(false)
    const [valuesSelected, setValuesSelected] = useState([]);
    const [selectOptionsFuente, setSelectOptionsFuente] = useState([]);
    const [selectOptionEmpresa, setSelectOptionsEmpresa] = useState([]);
    const [selectOptionsEcenario, setSelectOptionsEcenario] = useState([]);
    const [valueLabel, setValueLabel] = useState([]);
    const [valueData,setValuesData]=useState([])
    const [valueOptionsFuente, setvalueOptionsFuente] = useState({label:'',value:''});
    const [valueOptionEmpresa, setvalueOptionsEmpresa] = useState({label:'',value:''});
    const [valueOptionsEcenario, setvalueOptionsEcenario] = useState({label:'',value:''});
    highchartsSeriesLabel(Highcharts);


    const exportToPDF = () => {
        const element = document.getElementById('element-to-export');
    //@ts-ignore
        html2canvas(divRef.current).then(canvas => {
          const pdf = new jsPDF('p', 'mm', 'a4');
          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 100);
          pdf.save('Elecciones_presidenciales_2025.pdf');
        });}
    const {tituloProps,subtitleProps,selectValueProsp,formatDataStringData,disableFilterProps,
        numDecimalProps,
        pieTextProps,
        showPieTextInGraph,
        showLineTop,
        showSeries} = data
        const handleCapture = () => {
            if (divRef.current) {
              html2canvas(divRef.current).then(canvas => {
                // Generar imagen base64
                const imgData = canvas.toDataURL('image/png');
                // Crear un enlace para descargar la imagen
                const link = document.createElement('a');
                link.download = 'Elecciones_presidenciales_2025.png';
                link.href = imgData;
                link.click();
              });
            }
          };
        const exportExcel = (params: any) => {
            //Creo un nuevo excel
            const wb = XLSX.utils.book_new();
    
            //Se setean los datos al formato para el excel
            const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));
    
            //Se crea una pagina por cada cada grafico con sus respectivos datos
            XLSX.utils.book_append_sheet(wb, data, 'Grafico');
    
            //Se descarga el excel
            XLSX.writeFile(wb, "Data " + "Grafico" + ".xlsx")
        }
        const setDataGraficoForExcel = (data: any) => {
            let arrayAux: any = [];
            console.log('datafor excel',data);
            
            const newvalue =data.map((item: any) => {
                let obj:any = {}

                item.data.forEach((itemData:any)=>{
                    obj[itemData.propiedad]=itemData.valor
                })
                console.log('item',item.data);
                
                return {empresa:item.empresa,escenario:item.escenario,candidato:item.candidatos,...obj}


            })

            console.log('newvalue',newvalue);
            

           return newvalue
        }

        const getfuentes=async()=>{
            getFuenteGrafico().then((r: { data: any; }) =>{
                console.log('Fuente',r.data.data);
                setSelectOptionsFuente(r.data.data.map((item: { id: any; nombre: any; }) => ({ value: item.id, label: item.nombre })))
            })
       
        }
        const  getfuentesEmpresa=async (value:any)=>{
            let valueSelctEmpresa:any=[]
            await getEmpresasFuente(value.value).then((r:any) =>{
                console.log('Empresas',r.data.data);
                 valueSelctEmpresa =r.data.data.map((item: { id: any; nombre: any; }) => ({ value: item.nombre, label: item.nombre }))
                setSelectOptionsEmpresa(valueSelctEmpresa)
            })
            return valueSelctEmpresa
       
        }
        const  getfuentesEcenario=async (value:any,paramvalueOptionFuente:any =null,)=>{
            console.log('value',value,paramvalueOptionFuente);
           const valueSelectedFuente = paramvalueOptionFuente==null?valueOptionsFuente:paramvalueOptionFuente
       
            
            let restValueOptionsEscenario:any = []   
           await getEcenariosFuente(valueSelectedFuente.value,value.value).then((r:any) =>{
            restValueOptionsEscenario =r.data.data.map((item: { id: any; nombre: any; }) => ({ value: item.nombre, label: item.nombre }))
                setSelectOptionsEcenario(restValueOptionsEscenario)
            })
            console.log('restValueOptionsFuente',restValueOptionsEscenario);
            
            return restValueOptionsEscenario
       
        }
        const onChangeSelectFuente = async (value: any) => {
            setstateLoading(true)
            console.log('value',value);
            setvalueOptionsFuente(value)
            setvalueOptionsEmpresa({label:'',value:''})
            setvalueOptionsEcenario({label:'',value:''})
             const valueOptionEmpresas:any =await  getfuentesEmpresa(value)
            if(value.value=='1'){
                setvalueOptionsEmpresa({label:'Cadem',value:'Cadem'})
               await callGraph(value.value,'Cadem','')
               setstateLoading(false)

            }
            if(value.value=='2'){
                console.log('Valor empresa ',valueOptionEmpresas);
                setvalueOptionsEmpresa(valueOptionEmpresas[0])
               await callGraph(value.value,valueOptionEmpresas[0].value,'')
                selectedFirsOptionQuestion2(value)
                setstateLoading(false)

            }
            if(value.value=='3'){
                setvalueOptionsEmpresa(valueOptionEmpresas[0])
                const valueOptionEcenario:any =await getfuentesEcenario(valueOptionEmpresas[0],value)
                console.log('Valor Ecenario ',valueOptionEcenario);
                setvalueOptionsEcenario(valueOptionEcenario[0])
               await callGraph(value.value,valueOptionEmpresas[0].value,valueOptionEcenario[0].value)
               setstateLoading(false)

            }

        }
        const onChangeSelectEmpresa = (value: any) => {

            setvalueOptionsEmpresa(value)
            setvalueOptionsEcenario({label:'',value:''})
            if(valueOptionsFuente.value!='3'){
                callGraph(valueOptionsFuente.value,value.value,'')

            }
        
            getfuentesEcenario(value)
            
           

        }
        const onChangeSelectEcenario = (value: any) => {

            callGraph(valueOptionsFuente.value,valueOptionEmpresa.value,value.value)
            setvalueOptionsEcenario(value)

        }
        const callGraph= async(fuente='',empresa='',escenario='')=>{
            console.log('Call Funtion',fuente,empresa,escenario);
            
            await getGraficoPagina(fuente,empresa,escenario).then((r:any) =>{
                let labelsValue:any=[]
                let categoriasNoEliminar:any=[]
           
                setApiData(r.data.data)
                const newArrayValue= r.data.data.map((itemData:any)=>{
                     let data:any=[]
                     let labels:any=[]
            
                 itemData.data.forEach((item:any,index:any)=>{
                         data.push(item.valor=='-'?null:item.valor)
                         labels.push(item.propiedad)
                    })
                    labelsValue = labels
                    return {name:itemData.candidatos,data:data}
                    
                 })
                
                 labelsValue.forEach((label: any,index: any) => {
                    let sinValor = true;
                    newArrayValue.forEach((item: any) => {
                        if(item.data[index]!=null) {
                            sinValor = false
                        } 

                    })
                    if (!sinValor) {
                        categoriasNoEliminar.push(index)
                    }
                    

                 });

                console.log('Categorias no eliminar',categoriasNoEliminar);
                
                 const filteredLabels = labelsValue.filter((label: any, index: any) => categoriasNoEliminar.includes(index));
                 const filteredData = newArrayValue.map((item: { name: any; data: any[]; },indexFilterdata: any) => ({
                     name: item.name,
                     data: item.data.filter((_: any, index: any) => categoriasNoEliminar.includes(index)),
                     color:listaColoresChart[indexFilterdata]
                 }));
                 
                //  Actualizar los valores de data y labels
                 setValuesData(filteredData);
                setValueLabel(filteredLabels);
                setArrayColores(listaColoresChart.slice(0, 29));
                // setValueLabel(labelsValue)
            // setValuesData(newArrayValue)
 
             })
        }

       const selectedFirsOptionQuestion2 = async (valorFuente:any) =>{



        }
        const selectedFirsOptionQuestion3 = async () =>{

        

        }

        useEffect(() => {
            getfuentes()
            getfuentesEmpresa({label:'Espontánea',value:'1'})
            setvalueOptionsFuente({label:'Espontánea',value:'1'})
            setvalueOptionsEmpresa({label:'Cadem',value:'Cadem'})
            callGraph('1','Cadem','')
        }, [])
        
   
    
    return (
        <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className={`d-flex justify-content-center border-top-graph`} >
            <div className="bg-body rounded chart-content mt-3">
      {stateLoading ? <Loading loading={stateLoading} /> : null}

              <div className="d-flex gap-2">
              <div className="flex1">
                <p className="newFontSubTitle" style={{fontSize:14}}>Tipo de pregunta</p>
              <Select
                 className="react-select-container flex1"
                 classNamePrefix="react-select "
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={selectOptionsFuente}
                    onChange={onChangeSelectFuente}
                    value={valueOptionsFuente}
                />
</div>
                <div className="flex1">
                <p className="newFontSubTitle" style={{fontSize:14}}>Empresa</p>

                <Select
                 className="react-select-container"
                 classNamePrefix="react-select "
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={selectOptionEmpresa}
                    onChange={onChangeSelectEmpresa}
                    value={valueOptionEmpresa}
                />
                </div>
               
                {
                    valueOptionsFuente.value == '3'&& <div className="flex1">
                                        <p className="newFontSubTitle" style={{fontSize:14}}>Escenario</p>

<Select
                    className="react-select-container  "
                    classNamePrefix="react-select "
                       placeholder="Seleccionar..."
                       styles={customStyles}
                       closeMenuOnSelect={true}
                       options={selectOptionsEcenario}
                       onChange={onChangeSelectEcenario}
                       value={valueOptionsEcenario}
                   />
                    </div> 
                }
               
              </div>

                <div ref={divRef} className='mt-3 container-graphLine'>
                    <LineChart
                        allData={valueData}
                        title={'Elecciones presidenciales 2025'}
                        subtitle={''}
                        numDecimalProps={numDecimalProps}
                        pieTextProps={pieTextProps}
                        showSeries={showSeries}
                        formatDataStringData={formatDataStringData}
                        showPieTextInGraph={showPieTextInGraph}
                        labels={valueLabel}
                        colores={arrayColores}
                        exportExcel={exportExcel}
                        exportarImagen={handleCapture}
                        exportpdf={exportToPDF}
                        activeButton={true}
                    />
                </div>
             
            </div>
              {/* <ChartV5 /> */}
            </div>
          </div>
        </div>
      </div>
    )
}

export default GraficoELecciones